<template>
    <div class="tags">
        <router-link :class="{ active: allStoriesAreShown }" :to="urlPrefix + 'all'">
            <span>{{ allCategoriesLabel }}</span>
        </router-link>
        <router-link v-for="(category, index) in storyCategories" :key="index" :to="urlPrefix + category.slug" :class="{ active: category.slug === $route.params.slug }">
            <span v-text="category.title"></span>
        </router-link>
    </div>

</template>
<script>
    import helpers from './../../helpers'
    export default {
        props:{
            'storyCategories': {required: true}
        },
        data: function(){
            return {
                helpers: helpers
            }
        },
        computed: {
            allStoriesAreShown: function(){
                return this.$route.params.slug === 'all' || this.$route.params.slug === undefined;
            },
            urlPrefix: function () {

                let type = this.$route.fullPath.split('/')[2];

                if(helpers.getLocale() === 'nl') {
                    return '/' + helpers.getLocale() + '/' + type + '/categorie/';
                }
                return '/' + helpers.getLocale() + '/' + type +  '/category/';
            },
            allCategoriesLabel: function(){
                if(helpers.getLocale() === 'nl') {
                    return 'Alle';
                }
                return 'All';
            },
        }
    }
</script>
<style lang="scss" scoped>
    .tags a{
        min-width: 0;
        padding-left: 15px;
        padding-right: 15px;
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/site/components/stories/stories-category-switcher.vue